module.exports = __webpack_public_path__ + "img/Network.353a73ba.svg";